var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.4941.216876c-.206215.206216-.224957.528902-.056241.756291l.056241.065143 3.12461 3.12461c-1.4885 1.04511-2.601 2.60606-3.063265 4.45275-.077895.31118.111228.62662.422413.70453.311192.07783.626612-.11121.704512-.42247.41005-1.63805 1.42278-3.01197 2.77269-3.89869l1.40149 1.4016c-.54794.55878-.88582 1.32433-.88582 2.16872 0 1.71094 1.38695 3.09784 3.09783 3.09784.84447 0 1.60995-.3379 2.16884-.8858l4.5842 4.5844c.2269.2268.5946.2268.8214 0 .2062-.2062.225-.5289.0562-.7563l-.0562-.0651-4.7346-4.73521.0009-.00116-.92945-.92772-2.22262-2.22216.00155-.00062-2.23139-2.22903.00095-.00141-.87768-.87553-3.33512-3.334684c-.22683-.2268309-.594608-.2268309-.82144 0zm6.18361 7.005624 2.73779 2.73779c-.3485.33751-.82348.54521-1.34694.54521-1.06929 0-1.93614-.86684-1.93614-1.93614 0-.52345.20774-.99843.54529-1.34686zm1.39085-4.46514c-.77469 0-1.52638.11467-2.23734.32914l.95802.95738c.41495-.08199.84284-.12483 1.27932-.12483 3.03824 0 5.66124 2.07575 6.38704 4.98225.0778.31117.393.50045.7043.42277.3113-.07775.5005-.39303.4228-.70429-.8543-3.42077-3.9396-5.86242-7.51414-5.86242zm.15079 2.71779 2.94395 2.9435c-.0788-1.59298-1.35437-2.86732-2.94395-2.9435z",
    fill: "#7a8295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.d8176d694475250c7316aacf75dae423.svg";
export { ForwardRef as ReactComponent };